import React from "react";
import images from "../../images/index";
import "./About.css";
import { FaInstagram , FaLinkedin, FaMedium } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";

const about = () => {
  return (
    <>
      <section id="about">
        <h2 className="about-heading">About me</h2>
        <div className="about-container">
          <div className="about-img">
            <div className="cardContainer">
              <div className="profileDiv">
                <img src={images.profile} alt="profile photo" />
              </div>
              <div className="infoDiv">
                <div className="nameDiv">
                  <p className="name">Hrithik Kumar Singh</p>
                  <p className="role">Software Developer</p>
                </div>
                <div className="socialDiv">
                  <a href="https://www.linkedin.com/in/hrithikksingh" target="_blank">
                    <FaLinkedin />
                  </a>
                  <a href="https://medium.com/@hrithikkumarsingh" target="_blank">
                    <FaMedium />
                  </a>

                  <a href="https://instagram.com/codersvoice/" target="_blank">
                    <FaInstagram />
                  </a>

                  <a href="https://x.com/codersvoice_" target="_blank">
                    <FaSquareXTwitter />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="about-text">
            <h2>
              Hello,
              <img src={images.hand} alt="hand" style={{position:"relative", top: 10}} /> 
              {/* thode se styling ke liye abb external class nhi likhra mai  */}
            </h2>
            <p>
              I’m <span>Hrithik Kumar Singh</span>, a Software Developer at
              <a href="https://www.tp.com/en-us/" target="_blank"> Teleperformance.</a> Engineering robust systems with a focus on performance, scalability, and maintainability — turning innovative ideas into reliable software.
            </p>
            <br />
            <p>
            As a Software Developer, I bring a strong technical foundation, a collaborative mindset, and a passion for building impactful software. I focus on writing clean, maintainable code, contributing to system design, and delivering reliable applications that meet real-world needs. I enjoy working across the stack, solving complex challenges, and continuously learning to stay aligned with modern development practices and tools.
            </p>
            <a href={images.resume} target="_blank">
              My Resume
            </a>
          </div>
        </div>
        <div className="education-container">
          <div className="education-text">
            <h2>Education</h2>
          </div>
          <div className="education-items">
            <a href="https://aktu.ac.in/" target="_blank">
              <div className="edu-item">
                <div className="education-img">
                  <img src={images.edu} alt="edu" />
                </div>
                <div className="education-details">
                  <p>2021 - 2025</p>
                  <h2>Dr. A.P.J. Abdul Kalam Technical University, Lucknow</h2>
                  <p>Bachelor's of Technology (Computer Science & Engineering).</p>
                  {/* <p> */}
                  {/* CGPA: <span>8.06</span>
                  </p> */}
                </div>
              </div>
            </a>
            <a href="https://www.uniapply.com/school/police-modern-school-sector-1-vaishali-ghaziabad/" target="_blank">
              <div className="edu-item">
                <div className="education-img">
                  <img src={images.edu} alt="edu" />
                </div>
                <div className="education-details">
                  <p>2019 - 2021</p>
                  <h2>Police Modern School, Vaishali</h2>
                  <p>Secondary Education(12th) in PCM, CBSE</p>
                  {/* <p>
                    CGPA: <span>6.18</span>
                  </p> */}
                </div>
              </div>
            </a>
            {/* <a href="http://svmsindri.com/" target="_blank">
              <div className="edu-item">
                <div className="education-img">
                  <img src={images.edu} alt="edu" />
                </div>
                <div className="education-details">
                  <p>2018-2019</p>
                  <h2>Saraswati Vidya Mandir, Sindri</h2>
                  <p>High School, CBSE</p>
                   <p>
                    CGPA: <span>9</span>
                  </p> *
                </div>
              </div>
            </a> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default about;
